export enum Environment {
    RIO = 'rio',
    VW_QA = 'vw-qa',
    VW = 'vw',
}

export enum LogisticsTenant {
    RIO = 'vw.rio-dev',
    VW_QA = 'vw.qa',
    VW = 'vw.prod',
}
